/// <reference path="../../app.d.ts"/>
import { BasicPersistenceService } from '../../../../../shared/services/BasicPersistenceService';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { AppFormModel } from '../models/AppFormModel';

export class AppPersistenceService extends BasicPersistenceService<MglAddMembersAppDefinition> {
	private readonly applicationName: string;

	constructor(options: MglAddMembersAppOptions) {
		super(options);
		this.applicationName = 'addfamilymembersapplication';
	}

	public prepareApplicationSession(): void {
		const applicationModel = this.getApplicationModel();
		if (!applicationModel || applicationModel.Register !== this.applicationName) {
			this.setApplicationModel(
				new AppApplicationModel(this.applicationName)
			);
		}
	}

	public getPartnerAdvertisingDataFromStorage(): MglPartnerAdvertising {
		return {
			productActive: T.Utils.Store.get('productActive', T.Utils.Store.SESSION),
			productActiveCopayment: T.Utils.Store.get('productActiveCopayment', T.Utils.Store.SESSION),
			productActiveImage: T.Utils.Store.get('productActiveImage', T.Utils.Store.SESSION),
			productOverviewUrl: T.Utils.Store.get('productOverviewUrl', T.Utils.Store.SESSION),
			productActiveTitle: T.Utils.Store.get('productActiveTitle', T.Utils.Store.SESSION),
			productActiveOrderNumber: T.Utils.Store.get('productActiveOrderNumber', T.Utils.Store.SESSION),
			productActiveModel: T.Utils.Store.get('productActiveModel', T.Utils.Store.SESSION),
			productIsCashItem: T.Utils.Store.get('productIsCashItem', T.Utils.Store.SESSION),
			productLoginUser: T.Utils.Store.get('productLoginUser', T.Utils.Store.SESSION),
			productlist: T.Utils.Store.get('productlist', T.Utils.Store.SESSION)
		};
	}

	public hasCopayment(): boolean {
		const product = this.getPartnerAdvertisingDataFromStorage();
		return !!product.productActiveCopayment && product.productActiveCopayment !== '';
	}

	public getFormModelFromStore(): AppFormModel {
		const applicationModel = this.getApplicationModel();
		return applicationModel.FormModel;
	}

	public setFormModelToStore(formModel: AppFormModel): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.FormModel = formModel;
		this.setApplicationModel(applicationModel);
	}

	public setApplicationStepToStore(step: number): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.Step = step;
		this.setApplicationModel(applicationModel);
	}

	public getApplicationStepFromStore(): number {
		const applicationModel = this.getApplicationModel();
		return applicationModel.Step;
	}

	public getApplicationModel(): AppApplicationModel {
		const dataObject = this.getApplicationObject();
		return AppApplicationModel.createFromObject(dataObject);
	}
}
